import { Link, usePage } from '@inertiajs/react'
import { ReactNode } from 'react'

interface PageProps {
  flash?: {
    notice?: string
    alert?: string
  }
  [key: string]: unknown
}

interface AdminLayoutProps {
  children: ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
  const { flash } = usePage<PageProps>().props

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Header */}
      <nav className="bg-[#202020] text-white shadow-lg sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-between h-16 items-center">
            <div className="flex items-center">
              <Link href="/admin" className="text-xl font-bold">
                Super Admin
              </Link>
            </div>
            <div className="flex items-center space-x-4">
              <Link
                href="/admin"
                className="hover:text-[#FFC107] transition-colors"
              >
                Dashboard
              </Link>
              <Link
                href="/session"
                method="delete"
                as="button"
                className="bg-[#FFC107] text-[#202020] px-3 py-1 rounded hover:bg-[#e6ad06] transition-colors"
              >
                Salir
              </Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Contenido principal */}
      <main className="max-w-7xl mx-auto py-6 px-4">
        {flash?.notice && (
          <div className="mb-4 rounded border border-green-200 bg-green-50 px-4 py-3 text-sm text-green-700">
            {flash.notice}
          </div>
        )}
        {flash?.alert && (
          <div className="mb-4 rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
            {flash.alert}
          </div>
        )}
        {children}
      </main>
    </div>
  )
}
